export function installVendorAudioUnlock(sdk, root) {
  const originalCreate = sdk.createOpenAudioBtn
  const originalReplay = sdk.audioReplay
  let disposed = false

  function removeListeners() {
    root.removeEventListener('touchend', unlockAudio, true)
    root.removeEventListener('click', unlockAudio, true)
  }

  function armAudioUnlock() {
    removeListeners()
    if (disposed || !root.isConnected || sdk.dom !== root.id) return

    // Listen on the existing surface so the SDK still receives the first touch.
    // Its mobile WS overlay otherwise queues duplicate removeChild calls.
    root.addEventListener('touchend', unlockAudio, { capture: true, passive: true })
    root.addEventListener('click', unlockAudio, { capture: true, passive: true })
  }

  function reportAudioFailure(error) {
    console.warn('Bgs audio activation failed', error)
    armAudioUnlock()
  }

  function unlockAudio() {
    removeListeners()
    if (disposed || !root.isConnected || sdk.dom !== root.id) return

    try {
      // Safari requires audio activation within the user gesture, not a timer.
      const result = sdk.playAudio()
      sdk.audioActivated = true
      if (result && typeof result.catch === 'function') result.catch(reportAudioFailure)
    } catch (error) {
      reportAudioFailure(error)
    }
  }

  sdk.createOpenAudioBtn = armAudioUnlock
  sdk.audioReplay = unlockAudio

  return () => {
    disposed = true
    removeListeners()
    if (sdk.createOpenAudioBtn === armAudioUnlock) sdk.createOpenAudioBtn = originalCreate
    if (sdk.audioReplay === unlockAudio) sdk.audioReplay = originalReplay
  }
}
